import RecarregarDoCache from '@mui/icons-material/Refresh';
import { AppBar, Toolbar, Tooltip, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { action, computed, makeObservable, observable, when } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import '../../css/cabecalho.css';
import ReactComponent from '../ReactComponent';
import AlertasPauta from './AlertasPauta';
import BuscarProcessoPorNumero from './BuscarProcessoPorNumero';
import ControleDeSessaoPauta from './ControleDeSessaoPauta';
import EstadoPauta from './EstadoPauta';
import FiltrarPorNumerosProcessos from './FiltrarPorNumerosProcessos';
import ListaPautas from './ListaPautas';
import ProgressoProcessamentoLote from './ProgressoProcessamentoLote';
import RecarregarCacheServidor, { MODULO } from './RecarregarCacheServidor';
import ExportarResumoPauta from './toolbar/ExportarResumoPauta';
import ModalControlePermissaoSustentacao from './ModalControlePermissaoSustentacao';
import IncluirProcessoSessao from './IncluirProcessoSessao';

class ToolbarPautaJulgamento extends ReactComponent {
    cursor = 'pointer';

    constructor(props) {
        super(props);

        makeObservable(this, {
            cursor: observable,
            recarregarListaProcessos: action,
            dataLimiteEnvio: computed,
            corInformacaoDataLimiteEnvio: computed,
            mudarCursorWait: action,
            mudarCursorPointer: action
        });
    }

    recarregarListaProcessos = async () => {
        let promises = [];

        this.mudarCursorWait();
        promises.push(this.sessaoStore.recarregarListaProcessos());
        promises.push(this.pautaJulgamentoStore.carregarProcessosPautaveis());
        await Promise.all(promises);

        when(
            () => !this.pautaJulgamentoStore.carregandoProcessos && !this.salaSessaoStore.carregandoProcessos,
            () => this.mudarCursorPointer()
        );
    };

    get sessao() {
        return this.pautaJulgamentoStore.sessaoSelecionada;
    }

    get dataLimiteEnvio() {
        return this.pautaJulgamentoStore.dataLimiteEnvioPauta;
    }

    get corInformacaoDataLimiteEnvio() {
        let cor = 'white';

        if (
            this.dataLimiteEnvio &&
            moment(this.dataLimiteEnvio, 'DD-MM-YYYY-HH-mm-ss').isBefore(moment().startOf('day'), 'day')
        ) {
            cor = 'orange';
        }

        return cor;
    }

    mudarCursorWait() {
        this.cursor = 'wait';
    }

    mudarCursorPointer() {
        this.cursor = 'pointer';
    }

    render() {
        return (
            <AppBar
                position="static"
                className="selectionAmarelo"
                style={{ display: this.sessaoStore.idSessaoSelecionada !== -1 ? '' : 'none', zIndex: '1' }}
            >
                <Toolbar
                    sx={{
                        display: 'flex',
                        backgroundColor: '#1976d2',
                        minHeight: '40px',
                        color: 'black',
                        paddingRight: '8px',
                        justifyContent: 'space-between'
                    }}
                    variant="dense"
                >
                    <div
                        style={{
                            minHeight: '40px',
                            width: '38%',
                            display: 'flex',
                            alignItems: 'center',
                            minWidth: '630px',
                            color: 'white'
                        }}
                    >
                        <ListaPautas />
                        <EstadoPauta />
                        <div
                            style={{
                                boxShadow: '2px 0px 0px 0px rgba(0,0,0,0.2)',
                                width: '2px',
                                margin: '4px',
                                height: '24px',
                                color: 'white',
                                minWidth: '2px'
                            }}
                        />
                        <div style={{ marginLeft: '16px' }}>
                            <BuscarProcessoPorNumero
                                processos={this.pautaJulgamentoStore.processosSessao}
                                callbackAbrirProcesso={this.pautaJulgamentoStore.abrirProcesso}
                            />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignContent: 'center',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                color: 'white',
                                marginLeft: '2px'
                            }}
                        >
                            <FiltrarPorNumerosProcessos storeListagemProcessos={this.pautaJulgamentoStore} />
                        </div>
                        <div
                            style={{
                                boxShadow: '2px 0px 0px 0px rgba(0,0,0,0.2)',
                                width: '2px',
                                margin: '4px',
                                height: '24px',
                                color: 'white',
                                minWidth: '2px'
                            }}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'nowrap',
                            height: '40px',
                            minWidth: '370px'
                        }}
                    >
                        <Typography color="white">Data limite para envio:</Typography>
                        <Typography color={this.corInformacaoDataLimiteEnvio}>
                            &nbsp;{this.dataLimiteEnvio && this.dataLimiteEnvio.format('DD/MM/YYYY HH:mm')}
                        </Typography>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignContent: 'center',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            height: '40px',
                            color: 'white',
                            marginRight: '6px',
                            width: '38%'
                        }}
                    >
                        {this.renderRecarregar()}
                        <ControleDeSessaoPauta />
                        <ExportarResumoPauta />
                        <ProgressoProcessamentoLote />
                        <ModalControlePermissaoSustentacao />
                        <IncluirProcessoSessao />
                        <AlertasPauta />
                    </div>
                </Toolbar>
            </AppBar>
        );
    }

    renderRecarregar() {
        return (
            <>
                <Tooltip title={<Typography>Recarregar dados da pauta/sessão</Typography>}>
                    <IconButton
                        className="corBotaoAmarelo"
                        onClick={this.recarregarListaProcessos}
                    >
                        <RecarregarDoCache sx={{ color: 'white', cursor: this.cursor }} />
                    </IconButton>
                </Tooltip>
                <RecarregarCacheServidor modulo={MODULO.PAUTA} />
            </>
        );
    }

    renderConteudoItemMenu(pauta) {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                {pauta.descricao}
            </div>
        );
    }
}

export default inject('stores')(observer(ToolbarPautaJulgamento));
